import {Select, Option, Label} from "@ui5/webcomponents-react";
import {useEffect, useState} from "react";
import server from "../core/Server.ts";
import type {CustomerData} from "../core/CustomerData.ts";
import type {PluginData} from "../core/PluginData.ts";


interface PluginFilterProps {
    customer: CustomerData;
    onSelect: (plugin: PluginData|undefined) => void;
}

export function PluginFilter(props: PluginFilterProps) {

    const [disabled, setDisabled] = useState<true | undefined>();
    const [isLoading, setIsLoading] = useState<true | undefined>();
    const [pluginData, setPluginData] = useState<PluginData[]>([]);
    const [value, setValue] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            setDisabled(true);
            setIsLoading(true);
            const plugins = await server.getPluginList(props.customer.name);
            setPluginData(plugins);
            setDisabled(undefined);
            setIsLoading(undefined);
        };
        fetchData();
    }, [props.customer])

    return <div className="sc_filter">
        <Label className="sc_label">Plugin</Label>
        <Select
            className="sc_input"
            disabled={disabled}
            onChange={(e) => {
                setValue(e.target.value);
                const plugin = pluginData.find(plugin => plugin.name === e.target.value);
                props.onSelect(plugin);
            }}
            valueState="None"
            value={value}>
            <Option value="">Select plugin</Option>
            {pluginData.map(plugin => <Option value={plugin.name}>{plugin.name}</Option>)}
        </Select>
        {isLoading ? <span className="loader"/> : undefined}
    </div>
}
